import React, { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const invTyps = [
  { id: 1, value: '매출', label: '매출', color: 'primary' },
  { id: 2, value: '매입', label: '매입', color: 'secondary' },
];

const osTranOptions = [
  { id: 0, label: '전체', value: 'A', color: null },
  { id: 1, label: '해외', value: 'Y', color: 'info' },
  { id: 2, label: '국내', value: 'N', color: 'success' },
];

const reqCompOptions = [
  { id: 0, label: '전체', value: 'A', color: null },
  { id: 1, label: '발행완료', value: 'Y', color: 'success' },
  { id: 2, label: '미발행', value: 'N', color: 'warning' },
];

// 발행/거래/유형 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const TaxbillStatusList = ({ filters, onFilters }) => {
  const handleFilterBillType = useCallback((value) => onFilters('searchInvTyp', value), [onFilters]);
  const handleFilterOsTran = useCallback((value) => onFilters('searchOsTran', value || 'A'), [onFilters]);
  const handleFilterYn = useCallback((value) => onFilters('searchYn', value || 'A'), [onFilters]);

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="발행" options={reqCompOptions} value={filters?.searchYn} onChange={handleFilterYn} />
      <FilterToggleGroup label="거래" options={osTranOptions} value={filters?.searchOsTran} onChange={handleFilterOsTran} />
      <FilterToggleGroup label="유형" options={invTyps} value={filters?.searchInvTyp} onChange={handleFilterBillType} />
    </FilterToggleRow>
  );
};

export default TaxbillStatusList;
